import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const DEFAULT_COLOR = '#2f4f4f'

function normalizeColor(value) {
  if (typeof value !== 'string') {
    return DEFAULT_COLOR;
  }

  const color = value.trim();
  const isHexColor = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color);

  return isHexColor ? color : DEFAULT_COLOR;
}

const store = new Vuex.Store({
  state: {
    isLogged: false,
    token: false,
    colorPrincipal: DEFAULT_COLOR,
    saldoPrePago: {
      ativo: false,
      credito: 0,
    },
    logo: null,
    user: {},
  },
  getters: {
    rotuloEnvio(state) {
      const user = state.user || {};
      const conta = user.operador ? user.usuario : user._id;
      const contaId = conta && conta._id ? conta._id : conta;
      const bluesend = !!(user.lzv2 && user.lzv2.cliente_bluesend) ||
        !!(conta && conta.lzv2 && conta.lzv2.cliente_bluesend) ||
        String(contaId || "") === "66eac8eef58389f70fad372d";
      return (padrao, rotuloBluesend) => bluesend ? rotuloBluesend : padrao;
    },
  },
  mutations: {
    setConfig(state, config) {
      state.colorPrincipal = normalizeColor(config.colorPrincipal);
      state.logo = config.logo;
    },
    login(state, user) {
      state.isLogged = true;
      state.token = localStorage.getItem('token');
      state.colorPrincipal = normalizeColor(user.colorPrincipal);
      state.logo = user.logo;
      state.user = { ...user };
      if(user.saldoPrePago) state.saldoPrePago = user.saldoPrePago;
    },
    updateSaldoPrePago(state, saldoPrePago) {
      state.saldoPrePago = saldoPrePago;
    },
    logout(state) {
      state.isLogged = false;
      state.token = false;
      state.user = {};
      state.logo = null;
      state.colorPrincipal = DEFAULT_COLOR;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
  }
});

export default store